import React from 'react';
import type { SupportAttachmentKind } from '../../types/support';
import { formatSupportBytes } from '../../utils/supportAttachments';
import SupportVoicePlayer from './SupportVoicePlayer';

interface Props {
  kind: SupportAttachmentKind;
  name: string;
  size: number;
  previewUrl: string;
  durationSec?: number;
  onRemove: () => void;
}

/** Превью файла перед отправкой (локальный object URL). */
const SupportFilePreview: React.FC<Props> = ({
  kind,
  name,
  size,
  previewUrl,
  durationSec,
  onRemove,
}) => (
  <div className={`sc-preview sc-preview--${kind}`}>
    {kind === 'image' && <img src={previewUrl} alt={name} />}
    {kind === 'video' && <video src={previewUrl} muted playsInline preload="metadata" />}
    {(kind === 'voice' || kind === 'audio') && (
      <div className="sc-preview__voice">
        <SupportVoicePlayer
          src={previewUrl}
          durationSec={durationSec}
          variant="user"
          compact
          seed={previewUrl}
        />
      </div>
    )}
    {kind === 'file' && (
      <div className="sc-preview__file">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Z" />
          <polyline points="14 2 14 8 20 8" />
        </svg>
        <span className="sc-preview__file-name" title={name}>
          {name}
        </span>
        <span className="sc-preview__file-size">{formatSupportBytes(size)}</span>
      </div>
    )}
    <button
      type="button"
      className="sc-preview-remove"
      onClick={onRemove}
      aria-label={`Удалить ${name}`}
      title="Удалить"
    >
      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <line x1="18" y1="6" x2="6" y2="18" />
        <line x1="6" y1="6" x2="18" y2="18" />
      </svg>
    </button>
  </div>
);

export default SupportFilePreview;
